module.exports = __webpack_public_path__ + "assets/img/img16.152ad578.png";